<div type="button" class="cursor-pointer min-h-[18rem] h-[35rem] sm:h-[19rem] min-w-[19rem] sm:w-[19rem] w-full py-[2.4rem] px-[0.6rem] border-x-gray-200 border-solid border-[0.15rem] flex flex-col items-center justify-around rounded-[var(--dsr-radius-medium)] "
    [ngClass]="selected ? 'bg-light-dsr-color-primary text-white' : ''" [attr.aria-pressed]="selected" [attr.aria-label]="(accountType | translate) + ' - ' + (description | translate)">
    <div>
        <dsr-icon name="{{icon}}" size="3.2rem" class="!hidden sm:!block"
            color=" {{selected ? 'white' : 'black'}}" aria-hidden="true"></dsr-icon>
        <dsr-icon name="{{icon}}" size="5rem" class="sm:!hidden" color=" {{selected ? 'white' : 'black'}}" aria-hidden="true"></dsr-icon>
    </div>
    <div class="w-full sm:min-h-fit max-sm:min-h-fit  text-center text-wrap flex flex-col">
        <h3 class="dsr-typescale-body-medium-prominent !uppercase !text-wrap"
            [ngClass]="selected ? ' !text-white' : ''">
            {{accountType | translate}}
        </h3>
        <h3 class="dsr-typescale-body-medium-prominent !uppercase !text-wrap"
            [ngClass]="selected ? ' !text-white' : ''">
            {{secLine | translate}}
        </h3>
    </div>
    <div class="relative">
        <dsr-icon name="information-bubble" size="2.4rem" color=" {{selected ? 'white' : 'black'}}"
            [matTooltip]="description | translate" matTooltipPosition="below" matTooltipClass="subscriptions-doc-tooltip" aria-hidden="true"></dsr-icon>
    </div>
</div>